// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K9m_n","top":"styles_top__31mJ-"};